import AuthForm, { STATE_LOGIN } from "./recuperar_form";
import React from "react";
import { Card, Col, Row, Alert } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import LoadingScreen from 'react-loading-screen';
import "../../styles/estilos.css";
import "./login.css";
import { solicitarContraseniaFetch, enviarCorreo, limpiarSolicitarContrasenia } from "../../redux/actions/aLogin";
import { encriptarTrama } from "../../utils/Encriptar";
import logo from "assets/img/logo/logo_aig_login-2.png";

class RecuperarContrasenia extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      correo: "", vacios: false
    }

  }


  componentDidMount() {
    this.props.limpiarDatos();


  }
  toggleValidating(validate) {
    this.setState({ validate });
  }


  onClickRecuperar = (param) => {


    let correo = param.correo;
    if (correo.length === 0) {
      this.setState({ vacios: true })

    }
    else {
      var datosSolicitud =
      {
        cliEmail: correo,
        empCodigo: "AIGMETROPOLITANA"
      }
      datosSolicitud = JSON.stringify(datosSolicitud);

      const encrypted64Cambio = encriptarTrama(datosSolicitud);
      this.props.solicitarContrasenia(encrypted64Cambio);
    }



  }

  handleChangeCorreo = (event) => {

    this.setState({
      correo: event.target.value,
      vacios: false
    })
    if (this.props.datosSolicitarContrasenia.solicitarContraseniaError) {
      this.props.limpiarDatos();
    }

  }

  handleAuthState = authState => {

    if (authState === STATE_LOGIN) {
      this.props.history.push("/login");
    } else {
      this.props.history.push("/signup");
    }
  };

  handleLogoClick = () => {

    this.props.history.push("/");
  };


  render() {

    let isLoading = this.props.datosSolicitarContrasenia.solicitarContraseniaIsLoading === undefined ? false : this.props.datosSolicitarContrasenia.solicitarContraseniaIsLoading;
    return (
      <LoadingScreen
        loading={isLoading}
        bgColor='#f1f1f1'
        spinnerColor='#001871'
        textColor='#676767'
        logoSrc={logo}
        text='Solicitando...'
      >
        <main className="bg-light">
          <Row style={{ height: "100vh", justifyContent: "center", alignItems: "center", }} >
            <Col md={6} lg={4}>
              <Card body>
                <AuthForm
                  authState={this.props.authState}
                  onChangeAuthState={this.handleAuthState}
                  onLogoClick={this.handleLogoClick}
                  correo={this.state.correo}
                  handleChangeCorreo={this.handleChangeCorreo}
                  onClickRecuperar={this.onClickRecuperar}
                />
                <p></p>
                {this.props.datosSolicitarContrasenia.enviarCorreo && <Alert color="success">
                  <center><p>Estimado Usuario. El correo ha sido enviado exitosamente</p></center>
                </Alert>}
                {this.props.datosSolicitarContrasenia.solicitarContraseniaError && <Alert color="warning">
                  <center><p>No se pudo procesar su solicitud. Por favor intente más tarde</p></center>
                </Alert>}

              </Card>
            </Col>
          </Row>
        </main>
      </LoadingScreen>
    );
  }
}



const mapStateToProps = state => ({
  datosSolicitarContrasenia: state.datosSolicitarContrasenia,
  datosUsuario: state.datosUsuarios
});

const mapDispatchToProps = dispatch => {
  return {
    solicitarContrasenia: dataCambio => dispatch(solicitarContraseniaFetch(dataCambio)),
    setEnviarCorreo: estado => dispatch(enviarCorreo(estado)),
    limpiarDatos: () => dispatch(limpiarSolicitarContrasenia())
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(RecuperarContrasenia));
